import React from 'react'

const FormList = React.lazy(() => import('./FormList'))

export default FormList
